































































































import Vue from "vue";
import Component from "vue-class-component";
import info from "../../utils/info";
import { User } from "../../services/user/entities/user.interface";
import { UserReq } from "../../services/user/entities/user-req.interface";
import DeleteUserDialog from "../../components/admin/DeleteUserDialog.vue";
import UpdateUserDialog from "../../components/admin/UpdateUserDialog.vue";
import CreateUserDialog from "../../components/admin/CreateUserDialog.vue";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component({
  components: {
    DeleteUserDialog,
    UpdateUserDialog,
    CreateUserDialog
  }
})
export default class Users extends Vue {
  loadingUsers = false;
  dialogCreate = false;
  dialogUpdate = false;
  dialogDelete = false;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  user: UserReq = {
    userId: "",
    name: "",
    lastName: "",
    email: "",
    role: "",
    status: ""
  };
  headers = [
    {
      text: "Estatus",
      align: "start",
      sortable: true,
      value: "status"
    },
    {
      text: "E-mail",
      align: "start",
      sortable: false,
      value: "email"
    },
    {
      text: "Nombre y apellido",
      align: "start",
      sortable: false,
      value: "name"
    },
    {
      text: "Rol",
      align: "start",
      sortable: true,
      value: "role"
    },
    { text: "Acciones", value: "actions", sortable: false }
  ];
  componentKey = 1;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private openDialogUpdate(): void {
    this.dialogUpdate = true;
    this.componentKey++;
  }

  private created(): void {
    this.loadingUsers = true;
    this.$store.dispatch("user/getUsers").finally(() => {
      this.loadingUsers = false;
    });
  }

  private get users(): Array<User> {
    let users = this.$store.getters["user/getUsers"];

    users = users.map((user: User) => {
      return {
        id: user.userID,
        status: user.userStatus,
        email: user.userEmail,
        name: `${user.userName} ${user.userLastName}`,
        role: user.userRole
      };
    });

    return users;
  }

  private editUser(user: any): void {
    this.user.userId = user.id;
    this.user.name = user.name.split(" ")[0];
    this.user.lastName = user.name.split(" ")[1];
    this.user.email = user.email;
    this.user.role = user.role;
    this.user.status = user.status;
    this.dialogUpdate = true;
  }

  private deleteUser(user: any): void {
    this.user.email = user.email;
    this.user.userId = user.id;
    this.dialogDelete = true;
  }

  private get currentEmail(): string {
    return info.getEmail();
  }
}
